import { UserAuthenticate, User } from "../../UIS_models/user";
import reSourceService from "../ResourceService";
const urlEndpoint = "authenticate";
const authService = {
    GetUser: (user: UserAuthenticate): Promise<User | null> => {
        return reSourceService.post(`${urlEndpoint}/authpsc`, user);
    },
    ChangePassword: (authen:any): Promise<any | null> => {
        return reSourceService.post(`${urlEndpoint}/ChangePassword`, authen);
    },
    ResetPassword: (authen:any): Promise<any | null> => {
        return reSourceService.post(`${urlEndpoint}/ResetPassword`, authen);
    },
    AuthenSSO: (Modal:any): Promise<User | null> => {
        return reSourceService.post(`${urlEndpoint}/authadfs`, Modal);
    },
}
export default authService;